import request from '@/utils/request'
import { API_ENDPOINTS , API_REQUEST_METHODS} from '@/constants/api'

export const getVipGoodsList = () => {
  return request(API_ENDPOINTS.GET_VIP_GOODS)
}

/**
 * 提交订单
 */
export const commitVipOrder = (goodsId, code)=> {
  return request(API_ENDPOINTS.COMMIT_VIP_ORDER, {
    method: API_REQUEST_METHODS.POST,
    body: {
      'goods_id': goodsId,
      'code': code
    }
  })
}

export const commitNativeVipOrder = (goodsId) => {
  return request(API_ENDPOINTS.COMMIT_NATIVE_VIP_ORDER, {
    method: API_REQUEST_METHODS.POST,
    body: {
      'goods_id': goodsId
    }
  })
}

export const getWechatPayStatus = (no) => {
  const url = `${API_ENDPOINTS.GET_WECHAT_PAY_STATUS}?no=${encodeURIComponent(no)}`
  return request(url, { method: API_REQUEST_METHODS.GET })
}
